/**
 * Currency selector view
 * Consists of a radio input group and a suggest input field
 **/

import BaseView from '../../base-view';
import SuggestEvents from '../../events/suggest';
import Suggest from '../suggest/index';
import Model from './model';

export default BaseView.extend({

	events: {
		'change input[type="radio"]': 'onRadioChanged',
		'click .js-suggest-activate': 'onSuggestActivate',
		'click .js-suggest-cancel': 'onSuggestCancel'
	},

	initialize: function() {
		// create model
		this.model = new Model();

		// reference elements
		this.valueInput = this.query('.js-suggest-value');
		this.searchInput = this.query('.js-search-field');

		// create subview(s)
		this.suggestCurrencyView = new Suggest.Views.Main({
			el: '.js-search-currency',
			dataUrl: '/extranet/autocompletecurrency'
		});

		// listeners
		this.listenTo(this.suggestCurrencyView, SuggestEvents.SELECTED, this.onSuggestItemSelected);
		this.listenTo(this.suggestCurrencyView, SuggestEvents.CANCEL, this.onSuggestCancel);
		this.listenTo(this.model, 'change:Currency', this.onCurrencyChange);

		if (this.valueInput.value) {
			this.model.set('Currency', this.valueInput.value);
		}
	},

	/**
	 * Radio input change handler
	 * sets the Currency in the model and hides suggest view
	 **/
	onRadioChanged: function(e) {
		this.model.set('Currency', e.target.value);
		this.searchInput.classList.remove('is-persistent');
	},

	/**
	 * Item in suggest view selected handler
	 * makes the suggest view persistent
	 **/
	onSuggestItemSelected: function(value) {
		this.model.set('Currency', value);
		this.searchInput.classList.add('is-persistent');
	},

	/**
	 * Activates the suggest view
	 **/
	onSuggestActivate: function() {
		this.searchInput.value = '';
		this.searchInput.classList.add('is-persistent');
	},

	/**
	 * Cancel suggest handler
	 * sets everything back to its defaults
	 **/
	onSuggestCancel: function() {
		this.setDefaults();
	},

	/**
	 * Currency changed handler
	 * fills hidden field with currency from model
	 **/
	onCurrencyChange: function(model, currency) {
		this.valueInput.value = currency;
	},

	/**
	 * Set UI and data back to the defaults
	 * hide and clear suggest view
	 * select the first radio input
	 **/
	setDefaults: function() {
		// reset search field
		this.searchInput.classList.remove('is-persistent');
		this.searchInput.value = '';

		// select first option and fill hidden field with value
		var firstRadio = this.query('input[type="radio"]');
		if (firstRadio) {
			firstRadio.checked = true;
			this.model.set('Currency', firstRadio.value);
		}
	},

	render: function() {
		this.suggestCurrencyView.render();

		return this;
	}

});
